export default __webpack_public_path__ + "static/media/mobility_discussion_type.041531e9.svg";